import React, { useContext, useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useNavigate } from 'react-router-dom';
import Logo from '../../assets/images/logo.svg';
import { useTranslation, Trans } from "react-i18next";
import { useStores } from "../../core/stores/rootStore";
import Spinner from 'react-bootstrap/Spinner';
import { observer } from "mobx-react";
import Form from 'react-bootstrap/Form';
import { toast,ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { toJS } from "mobx";
const Login = (props) => {
    const { t, i18n } = useTranslation();

    let navigate = useNavigate();
    const {usersAdminStore,loginStore}= useStores();
    const [isLoading, setIsLoading] = useState(false);

    const { login, accountInfo } = loginStore;
    const [validated, setValidated] = useState(false);
    const [error, setError] = useState("");


    useEffect(() => {
        //toast.error("oh nou")
        //console.log(toJS(accountInfo))
        if (accountInfo?.token) {
            navigate(`/two-factor-authentication/${accountInfo?.token}`)
        }

    }, [accountInfo])

    async function fetchMyAPI(d) {
        
        setError("");

        setIsLoading(true);
        login(d).then(() => {            
        }).catch((e) => {
        }).finally(()=>setIsLoading(false));        
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            const formData = Object.fromEntries(new FormData(event.target).entries());
            fetchMyAPI(formData);
        }

        setValidated(true);        
    };

    return (
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
            
            <center>
                <h1 className="fw-normal mb-3 pb-3 text-primary">
                    <img src={Logo} width="50px" height="50px" alt="Logo" />
                    CH Finance
                </h1>
            </center>
            
            <Form.Group className="my-2">
                <Form.Label>{t('user')}</Form.Label>
                <Form.Control
                    name="username"
                    required
                    type="text"                    
                />
                <Form.Control.Feedback type="invalid">
                    {t('fieldRequired')}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="my-2">
                <Form.Label>{t('password')}</Form.Label>
                <Form.Control
                    name="password"
                    required
                    type="password"
                />
                <Form.Control.Feedback type="invalid">
                    {t('fieldRequired')}
                </Form.Control.Feedback>
            </Form.Group>

            {/*<div className="form-outline mb-2">
                <label className="form-label" htmlFor="userInput">{t('user')}</label>
                <div className="input-group mb-3">
                    <input type="text" id="userInput" name="username" className="form-control form-control-sm" />
                </div>
            </div>

            <div className="form-outline mb-2">
                <label className="form-label" htmlFor="passwordInput">{t('password')}</label>
                <div className="input-group mb-3">
                    <input type="password" id="passwordInput" name="password" className="form-control form-control-sm" />
                </div>
            </div>*/}
            
            {error && <div className="invalid-feedback" style={{display:"initial"}}><b>{error}</b></div>}

            <div className="pt-1 mb-2 d-grid">
                
                <button className="btn btn-secondary btn-lg btn-block" type="submit">
                    {isLoading && <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />}
                     &nbsp;{t('signIn')}</button>
            </div>
            <div className="d-flex">
                <Link style={{ marginLeft: 'auto' }} to="/recover-password">{t('recoverPassword')}</Link>
            </div>
            
        </Form>
    );
};

export default observer(Login);
